<form class="entry-page-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" novalidate>
    <h2 class="title">
        Please enter the email address associated with your Certemy account and we will send you a link to change your
        password
    </h2>
    <div class="form-group">
        <label class="form-label">Email:</label>
        <input
            type="email"
            formControlName="email"
            class="form-control"
            [ngClass]="{ error: form.controls.email.errors && message }"
        />
    </div>
    <div class="login-buttons"><button class="btn ch-button full-width" type="submit">send me the link</button></div>
    <div class="error-message" *ngIf="message">
        <span>{{ message }}</span>
    </div>
</form>
<footer class="entry-page-form-footer">
    Already have an account?<a class="cm-link" [routerLink]="['/entry/login']">Sign in</a>
</footer>
